// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"fffeb883","127":"636d4888","205":"a331b309","259":"a319254c","368":"05b65424","386":"0708b30e","419":"1cb7557b","518":"31b42453","660":"cd008c0f","661":"e676f759","768":"d32cccb7","969":"8071a080"}[chunkId] + ".chunk.css";
};